module.exports = __webpack_public_path__ + "static/media/ic_calendar.ddf18c3b.svg";